import './preprocessTilescape';
import TileOrb from './TileOrb';
import FogSheet from './FogSheet';
import { useEffect, memo, useRef } from 'react';
import { anime } from '@immutabl3/anime';
import { useAsset } from '@artica/assets';
import { Visible } from '@immutabl3/alchemy';
import tilescape from './tilescape.json';

const { size, positions: positionsData } = tilescape;

const DURATION = 4000;
const TILE_HEIGHT = size;

const positions = [
  ...positionsData,
  ...positionsData.map(([x, y, z]) => [x, y, z - size])
];

const generateAnimation = group => {
  const anim = anime({
    targets: { z: 0 },
    easing: 'linear',
    z: TILE_HEIGHT,
    loop: true,
    duration: DURATION,
    update({ animations: [{ currentValue }] }) {
      if (!group) return;
      group.position.z = currentValue;
    },
  });

  anim.play();

  return anim;
};

const IdleTilescape = memo(function IdleTilescape() {
  const groupRef = useRef();
  const { nodes, materials } = useAsset('tilescape');

  useEffect(() => {
    const anim = generateAnimation(groupRef.current);
    return () => {
      anim?.pause?.();
    };
  }, []);

  return (
    <>
      <FogSheet />
      <TileOrb />
      <group position={ [0, -(size * 10) - 5, size / 2] }>
        <group ref={ groupRef }>
          { positions.map((position, idx) => (
            <mesh
              key={ idx }
              geometry={ nodes.Plane.geometry }
              material={ materials.Terrain_PBR }
              position={ position }
            />
          )) }
        </group>
      </group>
    </>
  );
});

export default function Tilescape() {
  return (
    <Visible beaker="chapter1" start={ 0 } end={ 0.5 }>
      <IdleTilescape />
    </Visible>
  );
};